module.exports = __webpack_public_path__ + "static/blog-splash-2-thumbnail-b3ef4c1e7305356dcb9a645e00e81224.jpg";